export const QUESTIONNAIRE_ELEMENT = "questionnaire" as const;
